var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(-36.45 -352.191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M6.625,16H3.749A3.754,3.754,0,0,1,0,12.251v-8.5A3.754,3.754,0,0,1,3.749,0H9.5a3.754,3.754,0,0,1,3.75,3.749.625.625,0,0,1-1.25,0,2.5,2.5,0,0,0-2.5-2.5H3.749a2.5,2.5,0,0,0-2.5,2.5v8.5a2.5,2.5,0,0,0,2.5,2.5H6.625a.625.625,0,1,1,0,1.25Zm1.031-3.5H4.594a.625.625,0,0,1,0-1.25H7.656a.625.625,0,0,1,0,1.25Zm4.562-1.563a2.656,2.656,0,1,1,2.657-2.656A2.659,2.659,0,0,1,12.218,10.937Zm0-4.062a1.406,1.406,0,1,0,1.407,1.406A1.407,1.407,0,0,0,12.218,6.875ZM7.656,10.094H4.594a.625.625,0,0,1,0-1.25H7.656a.625.625,0,0,1,0,1.25Zm0-2.375H4.594a.625.625,0,0,1,0-1.25H7.656a.625.625,0,0,1,0,1.25Z",
    transform: "translate(36.45 352.191)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M11.407,11.938a.626.626,0,0,1-.625-.625,2.245,2.245,0,0,0-2.235-2.25h-.53a2.245,2.245,0,0,0-2.235,2.25.625.625,0,0,1-1.25,0,3.5,3.5,0,0,1,3.485-3.5h.53a3.5,3.5,0,0,1,3.485,3.5A.625.625,0,0,1,11.407,11.938ZM4.937,1.25H.625A.625.625,0,0,1,.625,0H4.937a.625.625,0,1,1,0,1.25Z",
    transform: "translate(40.419 356.253)",
    fill: "#eb742e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteIcon);
export default __webpack_public_path__ + "static/media/site-icon.86a42289c5020843a8f11694578a1439.svg";
export { ForwardRef as ReactComponent };